<template>
  <div v-if="this.isLoggedIn === true">
    <v-app>
      <NavDrawer />
      <v-content class="mx-8">
          <router-view></router-view>
      </v-content>
    </v-app>
  </div>

  <div v-else>
        <!-- desktop -->
    <div class="flex-container">
      <div class="flex-left">
        <div class="content-container">
        <section><p>College Credit Advantage Program</p>
          <a href="https://www.adelphi.edu/high-school-students/college-credit-advantage-program/" target="_blank" aria-label="Visit the College Credit Advantage Program Website for more info">Explore Adelphi’s CCAP Program</a> <svg style="width:16px;height:16px;" viewBox="0 0 24 24">
              <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
          </svg></section>
          </div>
      </div>
      <div class="flex-right">
        <div class="centering-container">
        <div class="login-wrapper">
          <div class="logo">
            <img
              src="./assets/adelphi-logo-white.png"
              alt="Adelphi University - New York"
              width="227"
              height="104"
            />
          </div>
          <div class="login-container">
            <span class="label_login tools_login">Sign in </span>
            <h1>Allow Students to earn college credit in high school — saving you tuition later.</h1>
            <p><button class="login-button" v-on:click="loginRedirect" aria-label="Login to CCAP Dashboard">Instructor Login</button></p>
			<p><button class="login-button" v-on:click="loginRedirect" aria-label="Login to CCAP Dashboard">Student Login</button></p>
            <!-- <button onclick="document.location='default.asp'" aria-label="High School Teacher Login">Instructor Login</button>
            <button onclick="document.location='default.asp'" aria-label="High School Administrator Login">Admin Login</button></p> -->
			<p class="tools_text"><a href="https://portal.adelphi.edu/retrieve-password/?email=">I need help accessing my account.</a></p>
            <p class="tools_text">If you don’t have an account, <a href="mailto:ccap@adelphi.edu" aria-label="Email the CCAP Program">please contact us</a>.</p></div>
            <div class="logo2">
            <img
              src="./assets/adelphi-logo-white.png"
              alt="Adelphi University - New York"
              width="150"
              height="auto"
            />
          </div>
        </div>
      </div>
  </div>

 <!-- mobile 

xxx

-->
</div>

  </div>
</template> 

<script>
// import Main from './components/Main';
// import Professional from './components/Professional';
// import Personal from './components/Personal';
// import TimeOff from './components/TimeOff';
// import Technology from './components/Technology'

import NavDrawer from "./components/NavDrawer";
// import axios from "axios";

    var ClientOAuth2 = require('client-oauth2')
const adelphiAuth = new ClientOAuth2({
  clientId: process.env.VUE_APP_OAUTH_CLIENT_ID,
  authorizationUri: 'https://login.adelphi.edu/ssp/module.php/adelphi/oidc/authorize.php',
  redirectUri: process.env.VUE_APP_OAUTH_REDIRECT,
  scopes: ['email', 'groups', 'openid'],
  state: parseInt(Math.random() * 1e12) + '_' + parseInt(Math.random() * 1e12) + '_' + parseInt(Math.random() * 1e12)
})

export default {
  name: "App",

  components: {
    NavDrawer,
  },

  data: () => ({
    tab: null,
    // logged_in: this.$store.getters.isLoggedIn,
    role: null,
    adelphiAuth: null,
    student_terms: null,
    // terms: [],
    // sections: [],
    sections_calendar: [],
    // hs_instructor_nav_items: [
    //     {
    //       title: "Rosters",
    //       icon: "mdi-account-multiple",
    //       route: "/roster",
    //     },
    //     {
    //       title: "Grades",
    //       icon: "mdi-account-multiple",
    //       route: "/grades",
    //     },
    //   ],
    //   student_nav_items: [
    //     // {
    //     //   title: "Profile",
    //     //   icon: "mdi-account",
    //     //   route: "/profile",
    //     // },
    //     {
    //       title: "Courses",
    //       icon: "mdi-pencil",
    //       route: "/courses"
    //     }
    //   ],
    
  }),

  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn
    },
    sections: function() {
      return this.$store.getters.sections
    },
    terms: function() {
      return this.$store.getters.terms
    },
    userType: function() {
      return this.$store.getters.userType
    },
    user_id: function() {
      return this.$store.getters.user_id
    },
    all_instructor_ids: function() {
      return this.$store.getters.all_instructor_ids
    },
	instructor_ids: function() {
		return this.$store.getters.instructor_ids
	},
    former_students_now_instructors: function() {
      return this.$store.getters.former_students_now_instructors
    }
  },

  mounted() {
    window.console.log(JSON.stringify(this.all_instructor_ids))

    window.console.log('USERID2: ' + this.user_id)

	window.console.log("THIS SHOULD RUN MANY TIMES")

	this.$store.dispatch('fetch_instructor_data')
		.then(() => {
			window.console.log("ID EXISTS: " + window.vm.$children[0].$store.state.instructor_ids.indexOf(window.vm.$children[0].user_id))
		})

window.oauth2Callback = function (uri) {
    window.console.log(uri)
    adelphiAuth.token.getToken(uri)
      .then(function (user) {
        // window.console.log(window.vm.$children[0].logged_in)
        window.console.log(user) //=> { accessToken: '...', tokenType: 'bearer', ... }

        
        
        window.vm.$children[0].$store.dispatch('login', user.accessToken)
          .then(() => {
            window.console.log('Success')
            // window.vm.$children[0].setUserAsLoggedIn(user)
            window.vm.$children[0].$store.dispatch('fetch_user_data', user.accessToken)
              .then(() => {
                window.console.log('STUDENT DATA SUCCESSFULLY FETCHED: ' + window.vm.$children[0].user_id)
                // TODO: Check if user ID is in the list of instructors to determine navigation / initial component.
				window.vm.$children[0].$store.dispatch('fetch_instructor_data')
					.then(() => {
						window.console.log('NEW INSTRUCTOR IDS: ' + window.vm.$children[0].$store.state.instructor_ids)
						window.console.log('NEW INSTRUCTORS ARRAY TYPE: ' + typeof(window.vm.$children[0].$store.state.instructor_ids))
						window.console.log("ID TYPE: " + typeof(window.vm.$children[0].user_id))
						window.console.log("ID NUMBER IN ARRAY TYPE: " + typeof(window.vm.$children[0].$store.state.instructor_ids[0]))
						window.console.log("ID EXISTS: " + window.vm.$children[0].$store.state.instructor_ids.indexOf(window.vm.$children[0].user_id))
						if (window.vm.$children[0].$store.state.instructor_ids.indexOf(window.vm.$children[0].user_id) !== -1) {
							window.vm.$children[0].$store.dispatch('setNavigation', 1)
							window.vm.$children[0].$router.push('/roster')
							window.console.log('Instructor ran :(')
						// }else if (window.vm.$children[0].former_students_now_instructors.indexOf(window.vm.$children[0].user_id) !== -1) {
						// 	window.vm.$children[0].$store.dispatch('setNavigation', 1)
						// 	window.vm.$children[0].$router.push('/roster')
						// 	window.console.log("alumni ran :)")
						}else {
							window.console.log("Student thing ran :(")
							window.vm.$children[0].$store.dispatch('setNavigation', 0)
							window.vm.$children[0].$router.push('/courses')
						}
					
					})
                
              })
            // if (window.vm.$children[0].userType == 0) {
            //   window.vm.$children[0].$router.push('/courses')
            // }else {
            //   window.vm.$children[0].$router.push('/roster')
            // }
              
          })
          .catch(err => window.console.error(err))

        // window.vm.$children[0].setUserAsLoggedIn(user)
        
        
        // // Make a request to the github API for the current user.
        // return popsicle.request(user.sign({
        //   method: 'get',
        //   url: 'https://api.github.com/user'
        // })).then(function (res) {
        //   console.log(res) //=> { body: { ... }, status: 200, headers: { ... } }
        // })
      })
  }

  if (localStorage.getItem('token') !== null) {
    this.$store.dispatch('fetch_user_data', localStorage.getItem('token'))
      .then(() => {
        if (this.all_instructor_ids.indexOf(this.user_id) !== -1 || this.former_students_now_instructors.indexOf(this.user_id) !== -1) {
          this.$store.dispatch('setNavigation', 1)
          this.$router.push('/roster')
          window.console.log('Nav set for instructor')
        }else {
          this.$store.dispatch('setNavigation', 0)
          this.$router.push('/courses')
          window.console.log('Nav set for student')
        }
      })
      .catch((err) => {
        window.console.error('Handling expired session ' + err)
        this.handleExpiredSession()
      })
  }

    // axios
    //   .get("./remote-apis/auth.php")
    //   .then((response) => {
    //     const json = response.data;
    //     if (json["msg"] == "authenticated") {
    //       this.logged_in = true;
    //     } else {
    //       // this.loginRedirect();
    //     }
    //   })
    //   .catch((error) => {
    //     window.console.error(error);
    //     // this.loginRedirect();
    //   });
  },

  // watch: {
  //     loader () {
  //         const l = this.loader
  //         this[l] = !this[l]

  //         setTimeout(() => (this[l] = false), 3000)

  //         this.loader = null
  //     },
  // },

  methods: {
    handleExpiredSession() {
      this.$store.dispatch('handleExpiredSession')
    },

    loginRedirect() {
      // window.location = "./remote-apis/auth-redirect.php";
      

      // Open the page in a new window, then redirect back to a page that calls our global `oauth2Callback` function.
      window.open(adelphiAuth.token.getUri())
    },

    async googleLogin() {
      const authToken = await this.$gAuth.getAuthCode()
      this.$store.dispatch('googleLogin', authToken)
        .then(function() {
          window.console.log('Google Auth Success')
          window.vm.$children[0].$router.push('/roster')
        }).catch(err => window.console.error(err))
    },

    setUserAsLoggedIn(user) {
        // this.logged_in = true
        fetch(process.env.VUE_APP_API_ROOT + '/users/current/student_record/', {
          
          headers: new Headers({
            'Authorization': 'Bearer '+user.accessToken
          })
        })
        .then(response => response.json())
        .then(data => {

          this.role = 0
          // this.nav_items = this.student_nav_items
          this.$router.push('/courses')
          this.terms = data.terms
          const sections = this.terms[0].sections
          window.console.log(sections)
          
          var sectionIds = []
          for (var i = 0; i < sections.length; i++) {
            window.console.log(sections[i].id)
            sectionIds.push(sections[i].id)
          }

          const sectionIdsString = sectionIds.join()
        
          fetch(process.env.process.env.VUE_APP_API_ROOT + '/sections/?id=' + sectionIdsString, {
            headers: new Headers({
              'Authorization': 'Bearer '+user.accessToken
            })
          })
          .then(response => response.json())
          .then(data => {

            fetch(process.env.process.env.VUE_APP_API_ROOT + '/section_calendars/?section__id='+sectionIdsString)
              .then(response => response.json())
              .then(data => {
                window.console.log(data)
              })

            this.sections = data.results
          })
          

        })
    }

    // saveAllChanges: function() {
    //     this.loader = 'loading'
    //     let formData = new FormData()
    //     let imageFile = this.headshot
    //     window.console.log(this.headshot);
    //     formData.append('uploaded_file', imageFile)
    //     //formData.append('primary_subdept', this.primary_subdept)

    //     axios.post('./remote-apis/save-photo.php', formData, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data'
    //         }
    //     })
    //         .then(response => {
    //             return(
    //                 window.console.log(response),
    //                 alert(response)
    //             )
    //         })
    //         .catch(error => {
    //             return(
    //             alert(error)
    //             )
    //         })
    // }
  },
};
</script>

<style>
@font-face {
	font-family: Graphik;
	src: url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.svg#Graphik) format("svg");
	font-weight: 400;
	font-style: normal
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.svg#Graphik) format("svg");font-weight:400;font-style:italic
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.svg#Graphik) format("svg");font-weight:300;font-style:normal
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.svg#Graphik) format("svg");font-weight:300;font-style:italic
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.svg#Graphik) format("svg");font-weight:600;font-style:normal
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.svg#Graphik) format("svg");font-weight:600;font-style:italic
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.svg#Graphik) format("svg");font-weight:700;font-style:normal
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.svg#Graphik) format("svg");font-weight:700;font-style:italic
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.svg#Graphik) format("svg");font-weight:500;font-style:normal
}

@font-face {
	font-family:Graphik;src:url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.eot#) format("eot"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.woff) format("woff"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.woff2) format("woff2"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.ttf) format("truetype"),url(//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.svg#Graphik) format("svg");font-weight:500;font-style:italic
}

.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto {
	padding-bottom: 5px
}

.row {
	padding-bottom: 1.2em
}

.v-content__wrap {
	position: absolute
}

.v-application {
	font-family: Graphik,Roboto,Arial,Helvetica,sans-serif!important
}

.v-application p {
	margin-bottom: 1.4em;
	font-family: Graphik,Arial,Helvetica,sans-serif;
	color: #504941;
	font-size: 1em;
	line-height: 1.8em;
	font-weight: 400
}

.v-application p.instruction {
	margin-bottom: 0;
	margin-top: -1em;
	font-family: Graphik,Arial,Helvetica,sans-serif;
	color: #504941;
	font-size: .85em;
	line-height: 1.8em;
	font-weight: 400;
	font-style: italic
}

.v-application a {
	text-decoration: none;
	color: #000!important;
	font-weight: 600;
	-webkit-transition: background .25s,border .25s,color .25s;
	transition: background .25s,border .25s,color .25s
}

.v-content__wrap a {
	color: #000!important;
	font-weight: 600;
	text-decoration: underline;
	-webkit-text-decoration-color: #ffb500;
	text-decoration-color: #ffb500;
	-webkit-transition: color .25s,background .25s,-webkit-text-decoration .25s;
	transition: color .25s,background .25s,-webkit-text-decoration .25s;
	transition: color .25s,background .25s,text-decoration .25s;
	transition: color .25s,background .25s,text-decoration .25s,-webkit-text-decoration .25s
}

.v-application a:focus,.v-application a:hover,.v-content__wrap a:focus,.v-content__wrap a:hover {
	color: #504941
}

.v-application a img {
	border-bottom-width: 0!important;
	border-bottom-color: none!important
}

.v-application a:hover img {
	border-bottom-width: 0!important;
	border-bottom-color: none!important
}

.v-application b a,.v-application strong a {
	font-weight: 700
}

h1 {
	font-size: 3em;
	margin: 1.1rem 0 1.8rem 0;
	line-height: 1.2em
}

h2 {
	font-size: 30px;
	line-height: 1.29167em;
	font-family: Graphik,Arial,Helvetica,sans-serif;
	font-weight: 500!important;
	margin: 0 0 .8em 0;
	color: #000!important
}

h3 {
	font-size: 2em;
	line-height: 1.29167em;
	font-weight: 600!important;
	color: #000;
	font-family: Graphik,Arial,Helvetica,sans-serif;
	font-weight: 300!important;
	margin: 1em 0 .5em 0
}

h4 {
	font-family: Graphik,sans-serif!important;
	font-weight: 500!important;
	color: #7a6855!important;
	font-size: 1rem!important;
	letter-spacing: .0625rem!important;
	text-transform: uppercase!important;
	margin: 1.6em 0 .4em 0!important;
	margin-left: -12px
}

.v-text-field .v-counter {
	margin-bottom: 1.1em
}

.v-tabs {
	margin-bottom: 1em
}

.v-tabs-slider-wrapper {
	height: 2px;
	left: 153px;
	width: 116px;
	color: #ffb500
}

.v-application .primary--text {
	color: #7a6855!important;
	caret-color: #7a6855!important
}

.v-text-field .v-input__control,.v-text-field fieldset {
	color: rgba(0,0,0,.3)!important
}

.v-btn {
	border-radius: 0
}

.v-label,span.label {
	font-size: 1.09em;
	line-height: 1.7;
	font-weight: 700!important;
	color: #000!important
}

span.black-text {
	color: #000
}

span.label-not-strong {
	font-weight: 400!important;
	color: #000!important;
	display: block;
	line-height: 1.8em;
	font-weight: 400;
	font-style: italic;
	font-size: .8em
}

.v-btn--outlined .v-btn__content .v-icon,.v-btn--round .v-btn__content .v-icon {
	color: #7a6855
}

.v-tooltip__content {
	background: rgba(0,0,0,.8)
}

div.flexbox {
	display: flex;
	align-items: center
}

.theme--light.v-data-table thead tr th {
	font-size: 1.09em;
	line-height: 1.7;
	font-weight: 700!important;
	color: #000!important
}

.v-data-table td {
	height: 50px;
	color: #504941;
	font-size: 1em!important;
	line-height: 1.8em;
	font-weight: 400;
	vertical-align: top;
	padding: 1em
}

.v-data-table table td div,.v-data-table td div {
	color: #504941;
	font-size: 1em!important;
	line-height: 2.3em;
	font-weight: 400
}

.v-data-table table td div {
	color: #504941;
	font-size: 1em!important;
	line-height: 2.2em;
	font-weight: 400;
	vertical-align: top;
	top: 50px
}

.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
	background-color: rgba(0,0,0,.03)
}

.v-expansion-panel::before {
	border-radius: 0
}

.v-application--is-ltr .v-expansion-panel-header {
	text-align: left;
	font-family: Graphik,sans-serif!important;
	font-weight: 500!important;
	color: #7a6855!important;
	font-size: 1rem!important;
	letter-spacing: .0625rem!important;
	text-transform: uppercase!important
}

.gold {
	background-color: #ffb500
}

.light-brown {
	background-color: #f1efed
}

.brown-text {
	color: #4f2c1d
}

.menu-btn {
	background-color: #000!important;
	color: #fff!important
}

.menu-btn:hover {
	background-color: #000!important;
	color: #ffb500!important;
	text-decoration: underline
}

.v-expansion-panel-content__wrap {
	padding: 0!important
}

.table_wrapper {
	margin-top: 40px;
	margin-bottom: 40px;
	min-height: .01%;
	position: relative
}

.table_wrapper_overflow {
	position: relative;
	border: 1px solid #ccc
}

.table_wrapper_overflow:after {
	background-color: rgba(0,0,0,0);
	background: -webkit-gradient(linear,left top,right top,from(rgba(0,0,0,0)),to(rgba(0,0,0,.1)));
	background: linear-gradient(to right,rgba(0,0,0,0),rgba(0,0,0,.1));
	width: 20px;
	height: 100%;
	position: absolute;
	top: 0;
	right: 0;
	content: ""
}

.table_wrapper_inner {
	overflow-y: hidden;
	-webkit-overflow-scrolling: touch;
	-ms-overflow-style: -ms-autohiding-scrollbar
}

table:not(.ui-datepicker-calendar) {
	width: 100%;
	border-collapse: collapse;
	border: 1px solid #eaeaea
}

table:not(.ui-datepicker-calendar) tr:nth-child(even) {
	background: #f2f2f2
}

table:not(.ui-datepicker-calendar) td,table:not(.ui-datepicker-calendar) th {
	padding: 10px 20px;
	vertical-align: top
}

table:not(.ui-datepicker-calendar) th,table:not(.ui-datepicker-calendar) thead td {
	font-weight: 400;
	font-family: Graphik-Bold;
	background: #000;
	border-width: 0;
	color: #ffb500;
	font-size: 12px;
	padding: 22px 20px;
	text-align: left;
	border: 1px solid #eaeaea!important
}

@media print {
	table:not(.ui-datepicker-calendar) th,table:not(.ui-datepicker-calendar) thead td {
		border: 1px solid #eaeaea
	}
}

table:not(.ui-datepicker-calendar) thead tr.header {
	width: auto;
	position: relative;
	top: auto;
	color: currentColor;
	margin-bottom: 0;
	z-index: 1
}

table:not(.ui-datepicker-calendar) td {
	font-weight: 400;
	font-family: Graphik-Regular;
	font-size: 13px;
	line-height: 1.53846;
	border: 1px solid #eaeaea
}

a.secondary-button,button.secondary-button {
	font-weight: 400;
	font-family: Graphik-Bold;
	display: inline-block;
	background: #ffb500;
	border: 2px solid #ffb500;
	color: #552f1b;
	font-size: 14px;
	padding: 8px;
	-webkit-transition: background-color .25s,border-color .25s;
	transition: background-color .25s,border-color .25s;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	border: solid 2px transparent;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-transition: .25s ease;
	transition: .25s ease
}

button.secondary-button:focus,button.secondary-button:hover {
	border-color: #ffb500;
	background-color: #fff
}

a.secondary-button:focus,a.secondary-button:hover {
	border-color: #ffb500;
	background-color: #fff
}

@media (min-width:740px) {
	table:not(.ui-datepicker-calendar) td {
		font-size: 15px;
		line-height: 1.46667
	}
}

table:not(.ui-datepicker-calendar) td b,table:not(.ui-datepicker-calendar) td strong,table:not(.ui-datepicker-calendar) tr b,table:not(.ui-datepicker-calendar) tr strong {
	font-weight: 400;
	font-family: Graphik-Bold
}

@media only screen and (max-width:600px) {
	.row {
		padding-bottom: 0
	}

	div.row~h3 {
		margin-top: 1.25em
	}

	div.row~h4 {
		margin-top: 1.25em
	}

	h1 {
		font-size: 2em;
		line-height: 1.25em
	}

	h2 {
		font-size: 1.8em;
		line-height: 1.15384615em
	}

	h3 {
		font-size: 1.75em;
		line-height: 1.15384615em;
		margin: 0 0 .3em 0
	}

	div.col-sm-3.col-12 {
		margin: .5em 0 -.4em 0
	}

	.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto {
		padding-bottom: 0
	}
}

@media (min-width:1264px) {
	.ccap-container {
		max-width: 1185px;
		width: 100%!important
	}
}

.login-button {
	background-color: #ffb500;
	border: 5px solid #ffb500;
	color: #552e1c;
	font: normal normal bold 16px/38px Graphik;
	font-size: 16px;
	text-align: center;
	padding: 8px 16px;
	width: 100%;
	margin-bottom: .9em;
	transition-delay: 0s;
	transition-duration: .25s;
	transition-property: all;
	transition-timing-function: ease;
	-webkit-box-direction: reverse
}

.login-button:focus,.login-button:hover {
	background-color: #fff;
	cursor: pointer
}

@font-face {
	font-family:Graphik-Regular;src:url(https://class.adelphi.edu/assets/fonts/Graphik-Regular.eot);src:url(https://class.adelphi.edu/assets/fonts/Graphik-Regular.eot?#iefix) format("embedded-opentype"),url(https://class.adelphi.edu/assets/fonts/Graphik-Regular.woff2) format("woff2"),url(https://class.adelphi.edu/assets/fonts/Graphik-Regular.woff) format("woff"),url(https://class.adelphi.edu/assets/fonts/Graphik-Regular.ttf) format("truetype")
}

@font-face {
	font-family:Graphik-Semibold;src:url(https://class.adelphi.edu/assets/fonts/Graphik-Semibold.eot);src:url(https://class.adelphi.edu/assets/fonts/Graphik-Semibold.eot?#iefix) format("embedded-opentype"),url(https://class.adelphi.edu/assets/fonts/Graphik-Semibold.woff2) format("woff2"),url(https://class.adelphi.edu/assets/fonts/Graphik-Semibold.woff) format("woff"),url(https://class.adelphi.edu/assets/fonts/Graphik-Semibold.ttf) format("truetype")
}

@font-face {
	font-family:Graphik-Bold;src:url(https://class.adelphi.edu/assets/fonts/Graphik-Bold.eot);src:url(https://class.adelphi.edu/assets/fonts/Graphik-Bold.eot?#iefix) format("embedded-opentype"),url(https://class.adelphi.edu/assets/fonts/Graphik-Bold.woff2) format("woff2"),url(https://class.adelphi.edu/assets/fonts/Graphik-Bold.woff) format("woff"),url(https://class.adelphi.edu/assets/fonts/Graphik-Bold.ttf) format("truetype")
}

@font-face {
	font-family:Tiempos-Bold;src:url(https://class.adelphi.edu/assets/fonts/TiemposText-Semibold.eot);src:url(https://class.adelphi.edu/assets/fonts/TiemposText-Semibold.eot?#iefix) format("embedded-opentype"),url(https://class.adelphi.edu/assets/fonts/TiemposText-Semibold.woff2) format("woff2"),url(https://class.adelphi.edu/assets/fonts/TiemposText-Semibold.woff) format("woff"),url(https://class.adelphi.edu/assets/fonts/TiemposText-Semibold.ttf) format("truetype")
}

* {
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	max-width: 100%
}

body {
	font-weight: 400;
	font-family: Graphik-Regular;
	min-width: 300px;
	position: static!important;
	margin: 0
}

.flex-container {
	display: flex;
	flex-direction: row
}

.flex-left {
	width: 70%;
	height: 100vh;
	margin: 0;
	background-color: #d3d3d3;
	background: url(~@/assets/bkg.jpg) no-repeat top right fixed;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover
}

.flex-left::before {
	width: 100%;
	height: 50%;
	display: block;
	position: fixed;
	left: 0;
	bottom: 0;
	background-image: linear-gradient(180deg,rgba(0,0,0,0) 0,#000 100%);
	content: "";
	opacity: .7
}

.flex-right {
	width: 30%;
	min-width: 500px;
	background-color: #504941;
	height: 100vh;
	margin: 0;
	z-index: 1
}

.centering-container {
	position: relative;
	top: 55%;
	transform: translateY(-50%)
}

div.logo {
	text-align: center;
	margin: auto;
	position: relative;
	padding-top: 20px
}

div.logo2 {
	display: none
}

.login-container {
	background-color: #fff;
	box-shadow: 2px 2px 30px #00000029;
	border-radius: 11px;
	opacity: 1;
	margin: 2em;
	min-height: 350px;
	text-align: left;
	padding: 0 2em
}

.tools_login {
	font-weight: 400;
	font-family: Graphik-Regular;
	display: inline-block;
	position: relative;
	font-size: 13px;
	line-height: 1.76923;
	margin-bottom: 0;
	margin-top: 2em
}

.tools_login:before {
	width: 6px;
	height: 1px;
	display: block;
	position: absolute;
	right: -12px;
	top: 10px;
	background: #ffb500;
	content: ""
}

.tools_login:after {
	width: 1px;
	height: 4px;
	display: block;
	position: absolute;
	right: -12px;
	top: 11px;
	background: #ffb500;
	content: ""
}

.tools_text {
	text-align: center;
	font: normal normal 400 16px/21px Graphik;
	letter-spacing: 0;
	padding-bottom: 40px
}

.tools_text a {
	color: #000;
	text-decoration: none;
	border-bottom: 1px solid #ffb500;
	font-weight: 700;
	white-space: nowrap
}

.flex-left .content-container {
	display: flex;
	flex-direction: column;
	height: 100vh
}

.flex-left section {
	margin-top: auto;
	margin-left: 2rem;
	margin-right: 2rem;
	margin-bottom: 2rem;
	z-index: 1
}

.flex-left section p {
	text-align: left;
	font: normal normal bold 50px/66px Tiempos Text;
	letter-spacing: 1px;
	color: #fff;
	text-shadow: 2px 2px 30px #00000029
}

.flex-left section a {
	color: #fff;
	font-weight: 400;
	font-family: Graphik-Bold;
	font-size: 14px;
	line-height: 1.14286;
	text-transform: uppercase;
	letter-spacing: .05em;
	text-decoration: none;
	border-bottom: 1px solid #ffb500;
	transition-delay: 0s;
	transition-duration: .25s;
	transition-property: all;
	transition-timing-function: ease;
	-webkit-box-direction: reverse
}

.flex-left section a:focus,.flex-left section a:hover {
	opacity: .8
}

.flex-left section svg {
	color: #fff;
	transform: translate(0,3px)
}

h1 {
	display: inline-block;
	font: normal normal bold 35px/59px Graphik;
	letter-spacing: 0;
	color: #000;
	line-height: 40px
}

button {
	background-color: #ffb500;
	border: 5px solid #ffb500;
	color: #552e1c;
	font: normal normal bold 16px/38px Graphik;
	font-size: 16px;
	text-align: center;
	padding: 8px 16px;
	width: 100%;
	margin-bottom: .9em;
	transition-delay: 0s;
	transition-duration: .25s;
	transition-property: all;
	transition-timing-function: ease;
	-webkit-box-direction: reverse
}

button:focus,button:hover {
	background-color: #fff;
	cursor: pointer
}

@media only screen and (max-width:882px) {
	.flex-container {
		display: flex;
		flex-direction: column
	}

	.flex-left {
		display: none
	}

	.flex-right {
		width: 100vw;
		background: url(~@/assets/bkg.jpg) no-repeat 70%;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
		background-attachment: fixed;
		background-position: center top;
		background-color: #504941
	}

	body {
		background-color: #504941
	}

	.logo {
		display: none
	}

	.logo2 {
		display: block!important;
		text-align: center;
		margin: auto;
		position: relative;
		padding-top: 1rem;
		padding-bottom: 1.2rem
	}

	h1 {
		display: block
	}

	.login-container {
		min-height: 350px;
		margin-top: 100px!important
	}
}

@media only screen and (max-width:411px) {
	.login-container {
		margin-top: 1em!important
	}

	h1 {
		font-size: 18px;
		line-height: 22px
	}
}

@media only screen and (max-width:500px) {
	.login-container {
		min-height: 350px
	}

	.flex-right {
		min-width: 100%
	}

	.tools_text {
		font-size: 13px;
		line-height: 1.53846
	}

	h1 {
		font-size: 22px;
		line-height: 28px
	}
}

@media only screen and (max-width:1250px) {
	.flex-left {
		background-color: #d3d3d3;
		background: url(~@/assets/bkg.jpg) no-repeat 80%;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover
	}
}

.post_featured_link_label {
	border-bottom: 1px solid transparent;
	-webkit-transition: .25s ease;
	transition: .25s ease;
}

.post_featured_link {
	font-family: Graphik, Ariel, sans-serif;
	font-weight: 700;
	font-size: 14px;
	line-height: 1.14286;
	text-transform: uppercase;
	color: #4f2c1d;
	letter-spacing: 0.05em;
}

.post_featured_link_wrap:focus .post_featured_link_label, .post_featured_link_wrap:hover .post_featured_link_label {
	border-bottom-color: #ffb500;
}
</style>
